import React from 'react';
import { Instagram, MessageCircle, MapPin, Phone } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/cfJQ2M88NC4RdEzfHL9tmR/logo-matambrito.png.jpg';
export function Footer() {
  const whatsappUrl = 'https://wa.me/5493417453398?text=Hola%2C+quiero+consultar+por+El+Matambrito+🍖';
  return <footer className="bg-[#080808] pt-20 pb-10 border-t border-white/5" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-185">
          {/* Column 1 - Brand */}
          <div className="space-y-6" data-id="element-186">
            <div className="flex items-center gap-3" data-id="element-187">
              <img src={LOGO_URL} alt="El Matambrito" className="w-12 h-12 rounded-full object-cover border border-matambrito-gold/30" data-id="element-188" />
              <div data-id="element-189">
                <h3 className="font-serif font-bold text-lg leading-none text-matambrito-cream" data-id="element-190">
                  El Matambrito
                </h3>
                <p className="text-matambrito-beige text-xs tracking-widest uppercase mt-1" data-id="element-191">
                  By Leo y Mary
                </p>
              </div>
            </div>
            <p className="text-matambrito-beige/70 text-sm leading-relaxed" data-id="element-192">
              Parrilla, patio y buena gente en el corazón de Villa Gobernador
              Gálvez.
            </p>
            <div className="flex gap-4" data-id="element-193">
              <a href="https://instagram.com/elmatambritovgg" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-matambrito-beige hover:bg-matambrito-red-fire hover:text-white transition-colors" aria-label="Instagram VGG" data-id="element-194">
                <Instagram className="w-5 h-5" data-id="element-195" />
              </a>
              <a href="https://instagram.com/elmatambritoleoymary" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-matambrito-beige hover:bg-matambrito-red-fire hover:text-white transition-colors" aria-label="Instagram Rosario" data-id="element-196">
                <Instagram className="w-5 h-5" data-id="element-197" />
              </a>
              <a href="https://instagram.com/coffe_allegra" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-matambrito-beige hover:bg-matambrito-alegra hover:text-white transition-colors" aria-label="Instagram Allegra" data-id="element-198">
                <Instagram className="w-5 h-5" data-id="element-199" />
              </a>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-matambrito-beige hover:bg-[#25D366] hover:text-white transition-colors" aria-label="WhatsApp" data-id="element-200">
                <MessageCircle className="w-5 h-5" data-id="element-201" />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div data-id="element-202">
            <h4 className="text-matambrito-cream font-serif font-bold text-lg mb-6" data-id="element-203">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-3" data-id="element-204">
              {[{
              label: 'Inicio',
              href: '#inicio'
            }, {
              label: 'Nosotros',
              href: '#nosotros'
            }, {
              label: 'Servicios',
              href: '#servicios'
            }, {
              label: 'Eventos',
              href: '#eventos'
            }, {
              label: 'Espacios',
              href: '#espacios'
            }, {
              label: 'Sucursales',
              href: '#sucursales'
            }, {
              label: 'Galería',
              href: '#galeria'
            }, {
              label: 'Contacto',
              href: '#contacto'
            }].map(link => <li key={link.label} data-id="element-205">
                  <a href={link.href} className="text-matambrito-beige/70 hover:text-matambrito-gold transition-colors text-sm" data-id="element-206">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div data-id="element-207">
            <h4 className="text-matambrito-cream font-serif font-bold text-lg mb-6" data-id="element-208">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-209">
              <li className="flex items-start gap-3 text-sm text-matambrito-beige/70" data-id="element-210">
                <MapPin className="w-4 h-4 text-matambrito-red-fire shrink-0 mt-0.5" data-id="element-211" />
                <span data-id="element-212">Av. San Martín 2666, VGG, Santa Fe</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-matambrito-beige/70" data-id="element-213">
                <Phone className="w-4 h-4 text-[#25D366] shrink-0" data-id="element-214" />
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-215">
                  341-7453398
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-matambrito-beige/70" data-id="element-216">
                <Instagram className="w-4 h-4 text-matambrito-beige shrink-0" data-id="element-217" />
                <a href="https://instagram.com/elmatambritovgg" className="hover:text-white transition-colors" data-id="element-218">
                  @elmatambritovgg
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-matambrito-beige/70" data-id="element-219">
                <Instagram className="w-4 h-4 text-matambrito-beige shrink-0" data-id="element-220" />
                <a href="https://instagram.com/elmatambritoleoymary" className="hover:text-white transition-colors" data-id="element-221">
                  @elmatambritoleoymary
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-matambrito-beige/70" data-id="element-222">
                <Instagram className="w-4 h-4 text-matambrito-alegra shrink-0" data-id="element-223" />
                <a href="https://instagram.com/coffe_allegra" className="hover:text-white transition-colors" data-id="element-224">
                  @coffe_allegra
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Hours */}
          <div data-id="element-225">
            <h4 className="text-matambrito-cream font-serif font-bold text-lg mb-6" data-id="element-226">
              Horarios
            </h4>
            <div className="space-y-4 text-sm" data-id="element-227">
              <div data-id="element-228">
                <p className="text-matambrito-gold font-medium mb-1 flex items-center gap-2" data-id="element-229">
                  <span data-id="element-230">🌞</span> Mediodía
                </p>
                <p className="text-matambrito-beige/70" data-id="element-231">
                  Martes a Domingo
                  <br data-id="element-232" />
                  11:00 a 16:00hs
                </p>
              </div>
              <div data-id="element-233">
                <p className="text-matambrito-gold font-medium mb-1 flex items-center gap-2" data-id="element-234">
                  <span data-id="element-235">🌙</span> Noche
                </p>
                <p className="text-matambrito-beige/70" data-id="element-236">
                  Lunes a Domingo
                  <br data-id="element-237" />
                  19:00 a 01:00hs
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10 pb-6" data-id="element-238">
          <p className="text-center font-serif text-2xl md:text-3xl text-matambrito-cream/90 italic mb-8" data-id="element-239">
            ❝ No es solo venir a comer. Es venir a disfrutar. ❞
          </p>

          {/* Logo below closing phrase */}
          <div className="flex justify-center mb-10" data-id="element-240">
            <img src={LOGO_URL} alt="El Matambrito" className="w-20 h-20 rounded-full object-cover opacity-70" data-id="element-241" />
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-matambrito-beige/50" data-id="element-242">
            <p data-id="element-243">©️ 2026 El Matambrito · By Leo y Mary</p>
            <p data-id="element-244">Villa Gobernador Gálvez, Santa Fe</p>
          </div>
        </div>
      </div>
    </footer>;
}